import { typographyCss } from '@creditornot/cb-ingredients';
import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';
import { Body1, Heading1 } from 'common/typography/Typography';

import { BASE_INTL_ID } from './constants';

type HeaderProps = { firstName?: string };

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-block-end: 48px;
`;

const Heading = styled(Heading1)`
  margin-block-end: 8px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    ${typographyCss.Heading3}
  }
`;

const Subheader = styled(Body1)`
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    ${typographyCss.Body3()}
  }
`;

const Header = ({ firstName }: HeaderProps) => {
  const { formatMessage } = useIntl();

  return (
    <Container>
      <Heading>
        {formatMessage({ id: `${BASE_INTL_ID}.header.welcome` })}
        {firstName ? `, ${firstName}! ` : '! '}
      </Heading>
      <Subheader>{formatMessage({ id: `${BASE_INTL_ID}.header.subheader` })}</Subheader>
    </Container>
  );
};

export default Header;
